import { render, staticRenderFns } from "./videoClipList.vue?vue&type=template&id=2eb20572&scoped=true"
import script from "./videoClipList.vue?vue&type=script&lang=js"
export * from "./videoClipList.vue?vue&type=script&lang=js"
import style0 from "./videoClipList.vue?vue&type=style&index=0&id=2eb20572&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eb20572",
  null
  
)

export default component.exports